import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilService } from 'src/app/service/util.service';
import { I18nService } from 'src/app/service/i18n.service';
import { FormControl } from '@angular/forms';
import * as CONSTANTS from '../../constants'


@Component({
    selector: 'app-additional-mortgage-details',
    templateUrl: './additional-mortgage-details.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./additional-mortgage-details.component.less']

})


export class AdditionalMortgageDetailsComponent implements OnInit {

    selectionY: boolean = null;
    selectionN: boolean = null;
    borderColorN: boolean = false;
    borderColorY: boolean = false;
    isSelected: boolean = false;
    displayValidation: boolean = false;
    coApplicantSelectionObj = { isCoApplicantPresent: "" };
    prequalObj: any;
    maturity: string;
    fixedRate = [];
    variableRate = [];
    interest!: FormControl;
    submitted: boolean = false;
    interestValue: string;
    loader: boolean = false;
    withinFour = "Within the next 4 months";
    morethanFour = "In 4 months or more";
    currLangEn = 'en';
    currLangFr = 'fr';
    currentLang: string;
    constructor(private util: UtilService, private router: Router, private _activatedRoute: ActivatedRoute, private i18nService: I18nService,
    ) {
        this.util.sidebarTitle.next('slideTitles.additionalMortgagedetails');
        this.prequalObj = this.util.getSessionStorage();
        this.currentLang = this.i18nService.getCurrentLang();
    }


    ngOnInit(): void {
        this.maturity = this.morethanFour;
        this.interest = new FormControl('');
    }

    validate(event: Event) {
        const inputEl = event.target as HTMLInputElement;
        let value = inputEl.value;
        value = value
            .replace(/[^0-9.]/g, '')
            .replace(/^\./, '')
            .replace(/(\..*?)\..*/g, '$1');

        const parts = value.split('.');
        if (parts[0].length > 1 && parts[0].startsWith('0')) {
            parts[0] = String(parseInt(parts[0], 10));
        }
        if (parts[0].length > 2) {
            parts[0] = parts[0].slice(0, 2);
        }
        if (parts[1] && parts[1].length > 2) {
            parts[1] = parts[1].slice(0, 2);
        }

        inputEl.value = parts.join('.');
        this.interestValue = inputEl.value;
    }

    buttonDisplay(selected) {
        if (this.displayValidation == true) {
            this.displayValidation = false;
        }
        if (selected == CONSTANTS.applicationConstants.yesLiteral) {
            this.maturity = this.withinFour;
            this.coApplicantSelectionObj.isCoApplicantPresent = CONSTANTS.applicationConstants.yesVal;
            this.selectionY = true;
            this.selectionN = false;
            this.borderColorY = true;
            this.borderColorN = false;
        }

        if (selected == CONSTANTS.applicationConstants.noLiteral) {
            this.maturity = this.morethanFour;
            this.coApplicantSelectionObj.isCoApplicantPresent = CONSTANTS.applicationConstants.noVal;
            this.selectionY = false;
            this.selectionN = true;
            this.borderColorY = false;
            this.borderColorN = true;
        }
    }
    rateApiCall() {
        this.util.getRateOffers().subscribe((resp: any) => {
            this.loader = false;
            sessionStorage.setItem("getProd", JSON.stringify(resp));
            this.router.navigate(['../your-online-exclusive-rate-offers'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
        }, (err) => {
            this.router.navigate(['../request-callback'], { relativeTo: this._activatedRoute });
        });
    }
    onContinue() {
        this.submitted = true;
        this.prequalObj["maturity"] = this.maturity;
        this.prequalObj.mortgage_interest_rate = this.interestValue;
        this.util.setSessionStorage(this.prequalObj);
        if (this.interest?.value >= 0 && this.interest?.value <= 99.99) {
            this.loader = true;
            this.rateApiCall();
        }
    }
}
